import * as React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import { Global } from '@emotion/react';
import './src/styles/fonts';
import { globalStyles } from './src/styles/global';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return (
    <>
      <Global styles={globalStyles} />
      {element}
    </>
  );
};

